import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import axios from 'axios'
import './assets/styles/theme.css'

const app = createApp(App)

// Bind axios to app config
app.config.globalProperties.$axios = axios

// Configure axios default base URL
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL

app.use(ElementPlus)
app.use(router)

app.mount('#app')
